export * from "./boards";
import * as configs from "./configs";
import * as comments from "./comments";

export const board = {
    ...comments,
    ...configs
};


